import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

interface UpdateDepositParams {
  teacherId: string;
  month: number;
  year: number;
  depositRefund: number;
  depositDeduction: number;
}

export const useUpdateDeposit = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ teacherId, month, year, depositRefund, depositDeduction }: UpdateDepositParams) => {
      const { data, error } = await supabase
        .from('teacher_monthly_reports')
        .update({
          deposit_refund: depositRefund,
          deposit_deduction: depositDeduction,
          updated_at: new Date().toISOString(),
        })
        .eq('teacher_id', teacherId)
        .eq('month', month)
        .eq('year', year)
        .select()
        .single();

      if (error) {
        throw error;
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-payroll'] });
      toast({
        title: 'บันทึกสำเร็จ',
        description: 'อัพเดทข้อมูลเงินประกันเรียบร้อยแล้ว',
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'เกิดข้อผิดพลาด',
        description: error.message,
        variant: 'destructive',
      });
    },
  });
};
